export default "__VITE_ASSET__DyIK1wic__"